module.exports = __webpack_public_path__ + "static/media/bold.575e4317.ttf";